/* eslint-disable typescript-enum/no-enum */

import { EComposerSessionType } from '../../types/composer_session';
import { EStreamPrivacy, EEventStreamingMethodVariant, EEventLatency } from '../../types/event';

export enum ETtrackingAddGraphicLocations {
  LEFT_PANEL = 'left_panel',
  SCENE_PREVIEW = 'scene_preview',
  SCENE_THUMBNAIL = 'scene_thumbnail',
}

export enum ESceneLocation {
  AT_END = 'at_end',
  IN_BETWEEN = 'in_between',
  DUPLICATE = 'as_duplicate',
}

export enum ESceneMode {
  LIVE = 'live',
  SIMULIVE = 'simulive',
}

export enum ELowerThirdType {
  GUEST = 'guest',
  OTHER = 'other',
}

export enum EUpgradeLocationType {
  BOTTOM_BAR = 'bottom_bar',
  START_EVENT_BUTTON = 'start_event_button',
  SEND_GUEST_SPEAKER_INVITE = 'send_guest_speaker_invite',
}

export enum ESlidesErrorReason {
  FILE_TOO_LARGE = 'file_too_large',
  UPLOAD_TIMED_OUT = 'upload_timed_out',
}

export enum ESlidesUploadState {
  UPLOADING = 'uploading',
  PROCESSING = 'processing',
}

export const EventPrivacy = {
  [EStreamPrivacy.NOBODY]: 'private',
  [EStreamPrivacy.PASSWORD]: 'password',
  [EStreamPrivacy.ANYBODY]: 'public',
  [EStreamPrivacy.UNLISTED]: 'unlisted',
  [EStreamPrivacy.EMBED_ONLY]: 'hide_from_vimeo',
} as const;

export const AudienceType = {
  [EComposerSessionType.VENUE]: 'venues',
  [EComposerSessionType.LIVE_EVENT]: 'live_event',
  [EComposerSessionType.INTERVIEW]: 'live_event',
  [EComposerSessionType.UNKNOWN]: null,
} as const;

export const ProductionMethod = {
  [EEventStreamingMethodVariant.Browser]: 'browser_studio',
  [EEventStreamingMethodVariant.Encoder]: 'stream_management',
} as const;

export const EventLatency = {
  [EEventLatency.FailSafe]: 'fail_safe_streaming',
  [EEventLatency.Standard]: 'standard_latency',
  [EEventLatency.Low]: 'low_latency',
} as const;

export enum ESimulcastValue {
  YOUTUBE = 'youtube',
  FACEBOOK = 'facebook',
  LINKEDIN = 'linkedin',
  VIMEO_OTT = 'vimeo_ott',
  RTMP = 'rtmp',
  INSTAGRAM = 'instagram',
  TIKTOK = 'tiktok',
  X = 'x',
}
